import defaultState from './app.defaultState'

export default defaultState
